/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Form, Formik } from "formik";
import { Grid } from "@mui/material";
import TextInput from "src/components/input/TextInput";
import {
  IitemAspiranteResponse,
} from "src/redux/api/types/aspirantes";
import { useObtenerUsuariosQuery } from "src/redux/api/usuariosApi";
import { usuariosRespToOpcionSelect } from "src/redux/api/types/usuarios";
import {
    IAsignarGestorForm,
  esquemaDeValidacion,
  setValoresInicialesNuevoMaestro,
} from "./utils";

export interface AsignarGestorProps {
    aspirante?: IitemAspiranteResponse,
    onSubmit: (valores: IAsignarGestorForm) => void;
}

const AsignarGestor = ({ aspirante, onSubmit }: AsignarGestorProps) => {
  const [valoresForm, setValoresForm] = useState(
    setValoresInicialesNuevoMaestro(aspirante),
  );

  const { data: usuariosResp } = useObtenerUsuariosQuery();


  return (
    <Formik
      enableReinitialize
      initialValues={valoresForm}
      validationSchema={esquemaDeValidacion}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, handleChange }) => {

        return (
          <Form autoComplete="off" id="form-asignar-gestor" style={{ width: "100%" }}>
            <Grid container spacing={2}>
              
              <Grid item xs={12} md={12}>
                <TextInput
                  label="Usuario gestor"
                  name="usuarioAsignadoId"
                  type="select"
                  opciones={
                    usuariosResp ? usuariosRespToOpcionSelect(usuariosResp) : []
                  }
                  data-testid="usuario-id"
                />
              </Grid>
             
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};

export default AsignarGestor;